{
  "fallback": {
    "400": "ข้อมูลบางอย่างไม่ถูกต้อง — ตรวจสิ่งที่กรอก",
    "401": "กรุณาเข้าสู่ระบบอีกครั้ง",
    "403": "คุณไม่มีสิทธิ์ทำสิ่งนี้",
    "404": "ไม่พบข้อมูลนี้ — อาจถูกลบไปแล้ว",
    "409": "ชนกับการแก้ไขอื่น — โหลดใหม่แล้วลองอีกครั้ง",
    "410": "หมดอายุแล้ว",
    "413": "ใหญ่เกินไป",
    "422": "ข้อมูลบางช่องยังไม่ครบหรือไม่ถูกต้อง",
    "423": "ถูกล็อกชั่วคราว — ลองใหม่ภายหลัง",
    "428": "โหลดข้อมูลล่าสุดก่อนบันทึก",
    "429": "ทำบ่อยเกินไป — รอสักครู่แล้วลองใหม่",
    "5xx": "เกิดปัญหาที่ฝั่งระบบ — ลองใหม่อีกสักครู่",
    "network": "เชื่อมต่อระบบร้านไม่ได้ — ตรวจการเชื่อมต่ออินเทอร์เน็ต",
    "unknown": "เกิดข้อผิดพลาด"
  },
  "field": {
    "required": "กรุณากรอก{{label}}",
    "must_be_positive": "{{label}}ต้องมากกว่า 0",
    "greater_than": "{{label}}ต้องมากกว่า {{limit}}",
    "greater_than_equal": "{{label}}ต้องไม่น้อยกว่า {{limit}}",
    "less_than": "{{label}}ต้องน้อยกว่า {{limit}}",
    "less_than_equal": "{{label}}ต้องไม่เกิน {{limit}}",
    "too_short": "{{label}}สั้นเกินไป",
    "too_long": "{{label}}ยาวเกินไป",
    "too_long_limit": "{{label}}ยาวเกินไป (ไม่เกิน {{limit}})",
    "pattern": "รูปแบบของ{{label}}ไม่ถูกต้อง",
    "whole_number": "{{label}}ต้องเป็นจำนวนเต็ม",
    "number": "{{label}}ต้องเป็นตัวเลข",
    "choice": "{{label}}: เลือกจากตัวเลือกที่มี",
    "email": "{{label}}: ไม่ใช่อีเมล",
    "date": "{{label}}: วันที่ไม่ถูกต้อง",
    "invalid": "{{label}}ไม่ถูกต้อง"
  },
  "hints": {
    "status": {
      "401": "เข้าสู่ระบบอีกครั้ง — สิ่งที่พิมพ์ไว้ถูกเก็บเป็นร่าง",
      "403": "ขอให้เจ้าของร้านเพิ่มสิทธิ์นี้ให้บัญชีของคุณ",
      "409": "โหลดใหม่เพื่อดูข้อมูลล่าสุด แล้วทำอีกครั้ง",
      "422": "แก้ช่องที่ขึ้นสีแดง แล้วบันทึกอีกครั้ง",
      "429": "รอประมาณ 1 นาทีแล้วลองใหม่",
      "5xx": "ลองใหม่ในอีก 1 นาที ถ้ายังเป็นอยู่ ให้คัดลอกรหัสอ้างอิงส่งให้เจ้าของร้าน",
      "network": "ตรวจ Wi-Fi หรือเน็ตมือถือ ฟอร์มที่มีร่างจะบันทึกเมื่อกลับมาออนไลน์"
    },
    "codes": {
      "version_conflict": "โหลดข้อมูลล่าสุดเพื่อดูว่าเปลี่ยนอะไร หรือเก็บของคุณแล้วบันทึกทับ",
      "insufficient_stock": "ดูสต็อกที่หน้าสินค้า — อาจขายไปแล้วที่หน้าร้านหรือออนไลน์",
      "oversell_conflict": "เปิดหน้าขายซ้ำ แล้วเลือกว่าใครได้การ์ดใบนี้",
      "tax_evidence_missing": "เปิดออเดอร์แล้วเพิ่มหลักฐานการส่งออก (ใบส่งพัสดุหรือเอกสารศุลกากร)",
      "raw_rank_required": "เลือก Rank A, B, C หรือ D ให้การ์ดใบนี้",
      "price_below_cost": "ตรวจราคา — ต่ำกว่าราคาที่ซื้อมา",
      "reason_required": "เขียนเหตุผลสั้นๆ เช่น \"เสียหาย\" หรือ \"นับใหม่\"",
      "account_locked": "รอตามเวลาที่แสดง หรือขอให้เจ้าของร้านปลดล็อกบัญชี",
      "issuer_registration_missing": "ตั้งค่า → ภาษี: ใส่เลข T ของร้าน",
      "order_not_paid": "กด ① 入金確認 ก่อนเมื่อเงินเข้าแล้ว",
      "identity_check_required": "ยืนยันตัวตน (本人確認) ของคนนี้ก่อน",
      "payment_has_funds": "ยืนยันรับเงินก่อน แล้วคืนเงินด้วยการคืนเงิน",
      "manager_approval_required": "ขอให้ผู้จัดการอนุมัติที่หน้านี้",
      "manager_pin_required": "ขอให้ผู้จัดการใส่ PIN",
      "taxfree_training_required": "ถามเจ้าของร้าน — ขายปลอดภาษีได้เฉพาะพนักงานที่ผ่านการอบรม"
    }
  },
  "codes": {
    "validation_failed": "ข้อมูลบางช่องยังไม่ครบหรือไม่ถูกต้อง — ดูช่องที่ขึ้นสีแดง",
    "invalid_reference": "ข้อมูลที่อ้างถึงไม่มีแล้ว — โหลดใหม่แล้วเลือกอีกครั้ง",
    "invalid_cursor": "หน้ารายการนี้เก่าแล้ว — กลับไปหน้าแรกของรายการ",
    "unauthorized": "กรุณาเข้าสู่ระบบอีกครั้ง",
    "token_expired": "การเข้าสู่ระบบหมดอายุแล้ว — กรุณาเข้าสู่ระบบอีกครั้ง",
    "forbidden": "คุณไม่มีสิทธิ์ทำสิ่งนี้",
    "not_found": "ไม่พบข้อมูลนี้ — อาจถูกลบไปแล้ว",
    "method_not_allowed": "ทำสิ่งนี้ที่หน้านี้ไม่ได้",
    "conflict": "ชนกับการแก้ไขอื่น — โหลดใหม่แล้วลองอีกครั้ง",
    "version_conflict": "มีคนแก้ข้อมูลนี้ก่อนคุณ",
    "idempotency_key_required": "ส่งข้อมูลอย่างปลอดภัยไม่ได้ — ลองอีกครั้ง",
    "if_match_required": "โหลดข้อมูลล่าสุดก่อนบันทึก",
    "idempotency_conflict": "เคยส่งไปแล้วด้วยข้อมูลอื่น — โหลดใหม่แล้วตรวจสอบ",
    "payload_too_large": "ข้อมูลใหญ่เกินไป ส่งไม่ได้ — ลดขนาดลง",
    "rate_limited": "ทำบ่อยเกินไปในเวลาสั้นๆ — รอสักครู่แล้วลองใหม่",
    "feature_disabled": "ฟีเจอร์นี้ยังไม่ได้เปิด",
    "invalid_state_transition": "ทำสิ่งนี้ในสถานะตอนนี้ไม่ได้",
    "upstream_unavailable": "ระบบบางส่วนไม่ตอบสนองตอนนี้ — ลองใหม่อีกสักครู่",
    "internal_error": "เกิดปัญหาที่ฝั่งระบบ",
    "insufficient_stock": "สินค้านี้ไม่มีของแล้ว",
    "unit_not_available": "การ์ดใบนี้ขายไม่ได้แล้ว",
    "hold_not_found": "ไม่พบการจองนี้",
    "hold_expired": "การจองหมดเวลาแล้ว",
    "oversell_conflict": "การ์ดใบนี้ขายไปแล้วในช่องทางอื่น",
    "location_not_allowed": "คุณไม่มีสิทธิ์ทำงานที่สาขา/คลังนี้",
    "hold_not_active": "การจองนี้ไม่มีผลแล้ว",
    "unit_already_sold": "การ์ดใบนี้ขายไปแล้ว",
    "reason_required": "การเปลี่ยนแปลงนี้ต้องใส่เหตุผล",
    "location_inactive": "สาขา/คลังนี้ปิดใช้งานอยู่",
    "location_has_stock": "สาขา/คลังนี้ยังมีของอยู่",
    "location_is_default": "ปิดสาขา/คลังหลักไม่ได้",
    "hold_type_not_allowed": "การ์ดชิ้นเดียวจองแบบนี้ไม่ได้",
    "hold_extension_limit": "การจองนี้ต่อเวลาเพิ่มไม่ได้แล้ว",
    "use_unit_action": "การ์ดชิ้นเดียวต้องปรับทีละใบ ไม่ใช่ปรับจำนวน",
    "not_consigned": "การ์ดใบนี้ไม่ใช่ของฝากขาย",
    "unit_on_hold": "การ์ดใบนี้ถูกจองอยู่ — ปล่อยการจองก่อนย้าย",
    "stream_capacity_reached": "ตอนนี้มีการเชื่อมต่อมากเกินไป — รอสักครู่",
    "conflict_not_open": "ปัญหาขายซ้ำนี้แก้ไปแล้ว",
    "unit_already_in_show": "การ์ดใบนี้อยู่ในไลฟ์แล้ว",
    "raw_rank_missing": "การ์ดใบนี้ยังไม่มี Rank — ตั้ง Rank (A/B/C/D) ก่อนพิมพ์ป้าย",
    "discrepancy_not_open": "ส่วนต่างสต็อกนี้จัดการไปแล้ว",
    "discrepancy_manual_fix": "ส่วนต่างสต็อกนี้ต้องแก้ทีละใบ — ดูวิธีที่แนะนำ",
    "sale_not_voidable": "ยกเลิกการขายนี้ไม่ได้แล้ว — รับคืนเป็นการคืนสินค้าแทน",
    "return_exceeds_sale": "จำนวนที่คืนมากกว่าที่ขายไป",
    "raw_rank_required": "การ์ดที่ไม่เกรดต้องมี Rank (A/B/C/D)",
    "handle_recently_used": "ที่อยู่เว็บนี้เพิ่งถูกใช้ — เลือกอันอื่น",
    "compare_at_evidence_missing": "ราคา \"ปกติ\" ต้องมีหลักฐาน (ยอดขาย 8 สัปดาห์ หรือราคาผู้ผลิต)",
    "duplicate_set": "มีชุดการ์ดรหัสนี้และภาษานี้อยู่แล้ว",
    "duplicate_card": "การ์ดใบนี้มีในชุดแล้ว",
    "in_use": "ยังมีสินค้าใช้ข้อมูลนี้อยู่",
    "not_enabled": "ฟีเจอร์นี้ยังไม่ได้เปิด",
    "unknown_attribute": "ไม่รู้จักข้อมูลเพิ่มเติมนี้",
    "invalid_attribute": "ค่าของข้อมูลเพิ่มเติมไม่ถูกต้อง",
    "category_cycle": "ใส่หมวดไว้ใต้ตัวเองไม่ได้",
    "category_too_deep": "หมวดซ้อนได้ไม่เกิน 3 ชั้น",
    "graded_fields_required": "การ์ดเกรดต้องมีบริษัทเกรด เกรด และเลขใบรับรอง",
    "condition_type_mismatch": "ชนิดสภาพไม่ตรงกับชนิดสินค้า",
    "invalid_grade": "เกรดต้องอยู่ระหว่าง 1–10 ทีละ 0.5",
    "invalid_raw_rank": "Rank ต้องเป็น A, B, C หรือ D",
    "invalid_cert_format": "เลขใบรับรองไม่ตรงรูปแบบของบริษัทเกรดนี้",
    "price_below_cost": "ราคาต่ำกว่าต้นทุน",
    "legacy_condition_alias_rejected": "ใช้ Rank A/B/C/D ของร้าน แทน NM/LP/MP/HP/DMG",
    "weight_required": "สินค้ากล่อง/ซีลต้องใส่น้ำหนัก",
    "duplicate_sku": "รหัสสินค้านี้ถูกใช้แล้ว",
    "invalid_ean": "บาร์โค้ดไม่ใช่เลข JAN/EAN-13 ที่ถูกต้อง",
    "reserved_handle": "ที่อยู่เว็บนี้สงวนไว้ — เลือกอันอื่น",
    "compare_at_type_not_allowed": "หลักฐานราคา \"ปกติ\" แบบนี้ใช้กับสินค้าชนิดนี้ไม่ได้",
    "export_price_low": "ราคาต่างประเทศต่ำกว่าราคาหน้าร้านแบบไม่รวมภาษีมาก",
    "channel_not_enabled": "ช่องทางขายนี้ยังไม่ได้เปิด",
    "last_variant": "สินค้าต้องมีอย่างน้อย 1 แบบ (สภาพ/ราคา)",
    "variant_in_use": "แบบนี้ยังมีสต็อกหรือยอดขาย — เก็บเข้าคลัง (archive) สินค้าแทน",
    "too_many_variants": "บันทึกหลายแบบเกินไปในครั้งเดียว — แบ่งบันทึก",
    "restore_window_expired": "สินค้านี้ถูกลบเกิน 30 วันแล้ว กู้คืนไม่ได้",
    "duplicate_cert": "มีการ์ดเลขใบรับรองนี้ลงขายแล้ว",
    "duplicate_barcode": "บาร์โค้ดนี้ถูกใช้กับสินค้าอื่นแล้ว",
    "similar_product_exists": "มีสินค้าการ์ดใบเดียวกันสภาพเดียวกันอยู่แล้ว",
    "too_many_media": "สินค้ามีรูปได้ไม่เกิน 10 รูป",
    "media_not_in_product": "เลือกรูปจากรูปของสินค้านี้",
    "media_failed": "ประมวลผลรูปไม่สำเร็จ",
    "no_media": "สินค้ายังไม่มีรูป",
    "publish_blocked": "ยังลงขายไม่ได้ — แก้รายการในเช็กลิสต์ก่อน",
    "invalid_rule": "เงื่อนไขของคอลเลกชันอัตโนมัติบางข้อไม่ถูกต้อง",
    "collection_is_smart": "สินค้าในคอลเลกชันอัตโนมัติมาจากเงื่อนไข",
    "file_too_large": "ไฟล์ใหญ่เกินไป",
    "unknown_columns": "ไฟล์มีคอลัมน์ที่ระบบไม่รู้จัก",
    "missing_columns": "ไฟล์ขาดคอลัมน์ที่จำเป็น",
    "too_many_rows": "ไฟล์มีจำนวนแถวมากเกินไป",
    "invalid_file_encoding": "อ่านไฟล์ไม่ได้ — บันทึกเป็น \"CSV UTF-8\"",
    "import_has_errors": "บางแถวมีข้อผิดพลาด — แก้ไขหรือเลือกข้ามแถวนั้น",
    "unknown_csv_profile": "ไม่รู้ว่าเป็นไฟล์ชนิดไหน — เริ่มจากไฟล์ตัวอย่าง",
    "currency_not_jpy": "ราคาในไฟล์นี้ต้องเป็นเงินเยน — ตรวจสกุลเงิน",
    "export_not_ready": "ไฟล์ส่งออกยังเตรียมไม่เสร็จ",
    "export_expired": "ไฟล์ส่งออกนี้หมดอายุแล้ว — ส่งออกใหม่",
    "variant_not_found": "ไม่มีสินค้าที่ตรงกับรหัสนี้",
    "unsupported_media_type": "ไม่รับไฟล์ชนิดนี้ — ใช้ JPEG, PNG, WebP, HEIC, GIF หรือ PDF",
    "upload_quota_exceeded": "อัปโหลดครบโควตาวันนี้แล้ว — ลองใหม่พรุ่งนี้",
    "upload_not_received": "ไฟล์ยังมาไม่ถึง — อัปโหลดใหม่",
    "restricted_upload_required": "บัตรประจำตัวและสลิปโอนต้องอัปโหลดผ่านช่องทางปลอดภัย",
    "purpose_not_allowed": "อัปโหลดไฟล์ชนิดนี้ที่นี่ไม่ได้",
    "upload_session_not_open": "รอบถ่ายรูปนี้ปิดแล้ว — เริ่มรอบใหม่บนคอมพิวเตอร์",
    "upload_session_full": "รอบถ่ายรูปนี้เต็มแล้ว",
    "handoff_token_invalid": "QR นี้หมดอายุแล้ว — เปิด QR ใหม่บนคอมพิวเตอร์",
    "media_restore_expired": "ไฟล์นี้ถูกลบนานเกินไป กู้คืนไม่ได้",
    "storage_unavailable": "เชื่อมต่อที่เก็บไฟล์ไม่ได้ตอนนี้ — ลองใหม่อีกสักครู่",
    "restricted_link_invalid": "ลิงก์ดูไฟล์นี้หมดอายุหรือใช้ไปแล้ว — เปิดไฟล์ใหม่อีกครั้ง",
    "retention_shorten_forbidden": "วันเก็บไฟล์นี้เลื่อนออกไปได้อย่างเดียว เลื่อนเข้ามาไม่ได้",
    "document_data_inconsistent": "ยอดเงินในเอกสารไม่ตรงกัน — ยังไม่ได้ออกเอกสาร",
    "document_type_not_supported": "ยังสร้างเอกสารชนิดนี้ไม่ได้",
    "document_already_superseded": "เอกสารนี้ถูกแทนด้วยฉบับแก้ไขแล้ว — ใช้ฉบับล่าสุด",
    "document_render_failed": "สร้างเอกสารไม่ได้ตอนนี้ — ระบบจะลองใหม่เอง",
    "recipient_name_required": "ใบกำกับภาษีเต็มรูปต้องมีชื่อผู้ซื้อ (宛名)",
    "issuer_registration_missing": "ยังไม่ได้ตั้งเลขทะเบียนใบกำกับภาษีของร้าน (登録番号)",
    "customs_data_incomplete": "ใส่น้ำหนัก รหัส HS และมูลค่าของทุกชิ้นก่อนพิมพ์",
    "document_issuer_incomplete": "ยังไม่ได้ตั้งชื่อร้านและที่อยู่สำหรับเอกสาร",
    "document_source_unsupported": "สร้างเอกสารนี้จากรายการนี้ไม่ได้",
    "order_not_payable": "ออเดอร์นี้ชำระเงินไม่ได้",
    "payment_method_unavailable": "วิธีชำระเงินนี้ใช้ไม่ได้",
    "payment_already_captured": "การชำระนี้ยืนยันไปแล้ว",
    "amount_mismatch": "ยอดเงินไม่ตรงกัน",
    "cart_not_found": "ไม่พบตะกร้า — เริ่มใหม่",
    "cart_line_not_found": "สินค้านี้ไม่อยู่ในตะกร้า",
    "cart_line_limit": "ตะกร้าเต็มแล้ว — เอาสินค้าออกก่อน",
    "product_unavailable": "สินค้านี้ซื้อออนไลน์ไม่ได้",
    "discount_not_found": "ไม่มีโค้ดส่วนลดนี้",
    "discount_expired": "โค้ดส่วนลดนี้หมดอายุแล้ว",
    "discount_not_started": "โค้ดส่วนลดนี้ยังใช้ไม่ได้",
    "discount_usage_exhausted": "โค้ดส่วนลดนี้ถูกใช้ครบแล้ว",
    "discount_min_subtotal": "ยอดในตะกร้ายังไม่ถึงขั้นต่ำของโค้ดนี้",
    "discount_channel": "โค้ดส่วนลดนี้ใช้ที่นี่ไม่ได้",
    "discount_no_eligible_lines": "ไม่มีสินค้าในตะกร้าที่ใช้โค้ดนี้ได้",
    "shipping_unavailable": "ส่งไปที่อยู่นี้ไม่ได้",
    "too_heavy": "พัสดุหนักเกินกว่าวิธีส่งที่มี",
    "address_required": "ต้องใส่ที่อยู่จัดส่งก่อน",
    "shipping_rate_invalid": "อัตราค่าส่งนี้ไม่ถูกต้อง",
    "shipping_zone_conflict": "ประเทศหรือจังหวัดนี้อยู่ในโซนจัดส่งอื่นแล้ว",
    "ddp_required": "ส่งไปสหรัฐฯ ต้องเป็นแบบ DDP (ร้านจ่ายภาษีนำเข้า)",
    "pickup_location_invalid": "สาขานี้ไม่มีบริการรับที่ร้าน",
    "postal_code_not_found": "ไม่พบรหัสไปรษณีย์นี้",
    "inventory_unavailable": "ตรวจสต็อกไม่ได้ตอนนี้",
    "catalog_unavailable": "โหลดข้อมูลสินค้าไม่ได้ตอนนี้",
    "tax_unavailable": "คำนวณภาษีไม่ได้ตอนนี้",
    "secondhand_license_required": "ปิดรับซื้อการ์ด (買取) และรับฝากขายไว้ก่อน จนกว่าจะกรอก 古物商許可 (公安委員会 และเลขใบอนุญาต) ใน ตั้งค่า → ข้อมูลร้าน",
    "web_orders_paused": "ตอนนี้หยุดรับออเดอร์บนเว็บชั่วคราว (ตั้งค่า → ขั้นตอนสั่งซื้อ) — หน้าร้าน/POS ใช้ได้ตามปกติ",
    "discount_type_not_supported": "ส่วนลดแบบนี้ยังใช้ไม่ได้",
    "cart_empty": "ตะกร้าว่าง — ใส่สินค้าก่อน",
    "checkout_not_found": "ไม่พบขั้นตอนสั่งซื้อนี้",
    "checkout_expired": "หมดเวลาทำรายการสั่งซื้อ — เริ่มใหม่จากตะกร้า",
    "checkout_already_placed": "ออเดอร์นี้สั่งไปแล้ว",
    "checkout_incomplete": "ยังมีข้อมูลที่ต้องกรอกก่อนสั่งซื้อ",
    "totals_changed": "ยอดรวมเปลี่ยน — ตรวจยอดใหม่แล้วยืนยันอีกครั้ง",
    "return_policy_ack_required": "กรุณายืนยันว่าอ่านนโยบายการคืนสินค้าแล้ว",
    "tokusho_ack_required": "กรุณายืนยันรายละเอียดคำสั่งซื้อ (特定商取引法に基づく表示)",
    "ddp_notice_ack_required": "กรุณายืนยันข้อมูลภาษีนำเข้าของปลายทางนี้",
    "payment_method_invalid": "ใช้วิธีจ่ายนี้กับออเดอร์นี้ไม่ได้ — เลือกวิธีอื่น",
    "payments_unavailable": "เตรียมการชำระเงินไม่ได้ตอนนี้",
    "identity_unavailable": "บันทึกข้อมูลลูกค้าไม่ได้ตอนนี้",
    "order_not_found": "ไม่พบออเดอร์นี้",
    "order_number_format_locked": "มีออเดอร์แล้ว จึงเปลี่ยนรูปแบบเลขออเดอร์ไม่ได้",
    "order_not_pending_payment": "ออเดอร์นี้ไม่ได้รอชำระเงินแล้ว",
    "method_mismatch": "ออเดอร์นี้ไม่ได้จ่ายด้วยการโอนเงิน — ไม่มีอะไรต้องแจ้งที่นี่",
    "payment_not_found": "ไม่พบการชำระของออเดอร์นี้",
    "nothing_to_resolve": "ไม่มีส่วนต่างการชำระที่ต้องจัดการ",
    "order_not_paid": "ออเดอร์ยังไม่ได้ชำระ — ยืนยันการรับเงินก่อน",
    "order_under_review": "ออเดอร์นี้ต้องให้ผู้จัดการอนุมัติก่อนเตรียมของ",
    "invalid_transition": "ทำขั้นนี้ตอนนี้ไม่ได้",
    "undo_window_passed": "เลยเวลาที่ย้อนขั้นนี้ได้แล้ว — ผู้จัดการย้อนได้โดยใส่หมายเหตุ",
    "insurance_required": "พัสดุมูลค่าสูงต้องมีประกันเต็มจำนวนและเซ็นรับ",
    "fulfillment_not_found": "ไม่พบการจัดส่งนี้",
    "order_not_shipped": "ออเดอร์นี้ยังไม่ได้ส่งอะไรเลย",
    "tracking_edit_window_passed": "แก้เลขพัสดุได้ภายใน 24 ชั่วโมงหลังส่งเท่านั้น",
    "pickup_qr_invalid": "รหัสรับของนี้ไม่ตรงกับออเดอร์ใด",
    "carrier_unknown": "ไม่รู้จักบริษัทขนส่งนี้",
    "tracking_format_invalid": "เลขพัสดุไม่ตรงรูปแบบของบริษัทขนส่ง",
    "tracking_url_invalid": "ลิงก์ติดตามต้องเป็นหน้าเว็บของบริษัทขนส่งเอง",
    "zonos_declaration_required": "พัสดุไปสหรัฐฯ ต้องมีเลขแจ้ง Zonos (จ่ายภาษีนำเข้าล่วงหน้า)",
    "declared_value_mismatch": "มูลค่าที่แจ้งศุลกากรต้องเป็นราคาขายจริง",
    "order_not_editable": "แก้ออเดอร์นี้ไม่ได้แล้ว",
    "order_line_not_found": "สินค้านี้ไม่อยู่ในออเดอร์",
    "use_return_flow": "ส่งของไปแล้ว — ใช้การคืนสินค้าแทนการยกเลิก",
    "order_already_cancelled": "ออเดอร์นี้ถูกยกเลิกไปแล้ว",
    "final_sale": "การ์ดขายแล้วไม่รับคืน — ยกเว้นเสียหาย ส่งผิด หรือไม่ตรงตามที่บอก",
    "return_window_passed": "เลยเวลาคืนสินค้านี้แล้ว",
    "return_not_allowed": "คืนสินค้านี้ด้วยเหตุผลนี้ไม่ได้",
    "return_not_found": "ไม่พบรายการคืนสินค้านี้",
    "return_already_open": "สินค้านี้มีรายการคืนเปิดอยู่แล้ว",
    "return_invalid_state": "ทำขั้นนี้กับรายการคืนตอนนี้ไม่ได้",
    "document_already_issued": "ออกเอกสารนี้ไปแล้ว — แก้ไขจากหน้าเอกสาร",
    "provider_disabled": "วิธีชำระเงินนี้ยังไม่ได้เปิด",
    "payment_not_pending": "การชำระนี้ไม่ได้รอเงินแล้ว",
    "method_not_allowed_for_channel": "ใช้วิธีชำระเงินนี้ที่นี่ไม่ได้",
    "refund_exceeds_captured": "ยอดคืนเงินมากกว่ายอดที่จ่ายมาและยังไม่ได้คืน",
    "store_credit_insufficient": "เครดิตร้านไม่พอ",
    "store_credit_expiry_exceeds_policy": "เครดิตร้านมีอายุได้ไม่เกิน 6 เดือน",
    "customer_required": "ต้องมีบัญชีลูกค้าสำหรับสิ่งนี้",
    "surcharge_disabled_by_default": "การเก็บค่าธรรมเนียมบัตรจากลูกค้าอาจผิดกฎของเครือข่ายบัตรหรือสัญญาเครื่องรูด — สอบถามผู้ให้บริการบัตรก่อนเปิด",
    "brand_not_supported": "เครื่องรูดบัตรนี้ไม่รับบัตรแบรนด์นี้",
    "payment_method_in_use": "ยังมีการชำระที่รอด้วยวิธีนี้ — ทำให้เสร็จหรือยกเลิกก่อน",
    "insufficient_tender": "เงินสดที่รับมาน้อยกว่ายอด",
    "edc_duplicate_approval": "เลขอนุมัติบัตรนี้บันทึกไปแล้ววันนี้",
    "four_eyes_required": "สิ่งที่คุณขอต้องให้ผู้จัดการอีกคนอนุมัติ",
    "refund_method_not_allowed": "คืนเงินการชำระนี้ด้วยวิธีนี้ไม่ได้",
    "payment_has_funds": "เงินของการชำระนี้เข้ามาแล้ว — ยืนยันรับเงินแล้วคืนเงินแทนการยกเลิก",
    "tax_evidence_missing": "ยังไม่มีหลักฐานการส่งออก",
    "tax_free_not_eligible": "ไม่เข้าเงื่อนไขซื้อแบบปลอดภาษี",
    "tax_free_threshold_not_met": "ยอดยังไม่ถึงขั้นต่ำของการซื้อแบบปลอดภาษี",
    "discount_exceeds_total": "ส่วนลดมากกว่ายอดที่ลดได้",
    "discount_line_unknown": "ส่วนลดอ้างถึงรายการที่ไม่มีในเอกสาร",
    "taxfree_web_not_allowed": "ขายแบบปลอดภาษีได้ที่หน้าร้านเท่านั้น",
    "taxfree_mixed_receipt": "ใบเสร็จปลอดภาษีมีสินค้าที่ไม่เข้าเงื่อนไข — แยกใบเสร็จ",
    "taxfree_detail_required": "สินค้าปลอดภาษีราคาสูงต้องมีรายละเอียดและหมายเลขซีเรียล",
    "taxfree_not_licensed": "ร้านยังไม่มีใบอนุญาตขายปลอดภาษี",
    "commission_outside_settlement": "รายการค่าคอมใส่ได้เฉพาะในใบสรุปยอดผู้ฝาก",
    "calculation_not_found": "ไม่มีผลคำนวณภาษีที่บันทึกไว้ของเอกสารนี้",
    "invalid_registration_number": "เลขทะเบียนต้องเป็น T ตามด้วยตัวเลข 13 หลัก",
    "field_locked": "ค่านี้ล็อกไว้ แก้ที่นี่ไม่ได้",
    "wari2_ended": "2割特例 สิ้นสุดแล้วในงวดภาษีที่มีวันที่ 2026-09-30",
    "wari3_not_allowed": "3割特例 ใช้ได้เฉพาะผู้ประกอบการบุคคลธรรมดาปี 2027–2028",
    "simplified_taxation_dates_required": "簡易課税 ต้องระบุช่วงวันที่เริ่ม–สิ้นสุด",
    "effective_from_too_early": "วันเริ่มใช้ต้องเป็นวันนี้ (ถ้ายังไม่มีเอกสาร) หรือหลังจากนี้",
    "rounding_change_period_boundary": "การเปลี่ยนวิธีปัดเศษมีผลตั้งแต่งวดภาษีถัดไป",
    "append_only": "ประวัติการตั้งค่าแก้ไม่ได้ — สร้างฉบับใหม่",
    "settings_version_not_found": "ไม่พบฉบับการตั้งค่าภาษีนี้",
    "legal_calendar_event_not_found": "ไม่พบรายการในปฏิทินกฎหมายนี้",
    "source_url_required": "เปลี่ยนวันที่ตามกฎหมายต้องใส่ลิงก์แหล่งที่มา",
    "market_not_found": "ไม่พบตลาดนี้",
    "market_exists": "มีตลาดรหัสนี้อยู่แล้ว",
    "market_country_conflict": "หนึ่งประเทศอยู่ได้ในตลาดเดียว",
    "market_protected": "ลบหรือปิดตลาดนี้ไม่ได้",
    "fx_rate_not_found": "ไม่พบอัตราแลกเปลี่ยน",
    "fx_rate_unavailable": "ไม่มีอัตราแลกเปลี่ยนของสกุลเงินนี้",
    "mrz_invalid": "อ่านพาสปอร์ตไม่ได้ — สแกน 2 บรรทัดล่างอีกครั้ง",
    "verification_not_found": "ไม่พบการตรวจสิทธิ์ปลอดภาษี",
    "verification_expired": "การตรวจสิทธิ์ปลอดภาษีหมดอายุ — สแกนพาสปอร์ตใหม่",
    "verification_consumed": "การตรวจสิทธิ์ปลอดภาษีนี้ใช้กับใบเสร็จไปแล้ว",
    "calc_mismatch": "ยอดเงินไม่ตรงกับผลคำนวณภาษีที่บันทึกไว้ของเอกสารนี้",
    "already_confirmed": "ศุลกากรยืนยันรายการนี้แล้ว — แก้ไม่ได้",
    "taxfree_record_not_found": "ไม่พบรายการปลอดภาษี",
    "taxfree_record_cancelled": "รายการปลอดภาษีนี้ถูกยกเลิกแล้ว",
    "export_batch_not_found": "ไม่พบชุดส่งออกนี้",
    "export_batch_empty": "ไม่มีรายการปลอดภาษีที่ต้องส่งออกในช่วงนี้",
    "transmission_not_retryable": "การส่งนี้อยู่ในสถานะที่ส่งซ้ำไม่ได้",
    "already_final": "บันทึกผลศุลกากรของรายการปลอดภาษีนี้ไปแล้ว",
    "customs_not_applicable": "รายการปลอดภาษีนี้ไม่ได้รอการยืนยันจากศุลกากร",
    "nta_api_not_enabled": "ยังไม่ได้เปิดการเชื่อมต่อกรมสรรพากรญี่ปุ่น — นำเข้าผลศุลกากรเป็นไฟล์แทน",
    "customs_import_invalid": "อ่านไฟล์ผลศุลกากรไม่ได้",
    "taxfree_refund_not_allowed": "ยังขอคืนภาษีสำหรับรายการนี้ไม่ได้ตอนนี้",
    "export_evidence_not_found": "ไม่มีหลักฐานการส่งออกของออเดอร์นี้",
    "evidence_item_not_found": "ไม่พบหลักฐานนี้",
    "evidence_locked": "ลบหลักฐานได้ภายใน 24 ชั่วโมงเท่านั้น — ตอนนี้ต้องเก็บไว้ 7 ปี",
    "evidence_not_required": "ออเดอร์นี้ไม่ต้องใช้หลักฐานการส่งออกแล้ว",
    "tax_document_not_found": "ไม่มีข้อมูลภาษีของเอกสารนี้",
    "document_type_not_applicable": "ออกเอกสารชนิดนี้สำหรับการขายหรือการคืนเงินนี้ไม่ได้",
    "report_range_invalid": "ช่วงวันที่ของรายงานไม่ถูกต้อง",
    "taxfree_training_required": "เฉพาะพนักงานที่ผ่านการอบรมขายปลอดภาษีเท่านั้น",
    "calculation_locked": "ผลคำนวณภาษีนี้ใช้กับเอกสารที่ออกแล้ว เปลี่ยนไม่ได้",
    "customs_after_deadline": "ศุลกากรตรวจหลังครบ 90 วัน — การขายนี้ยังคิดภาษีตามปกติ",
    "taxfree_payload_invalid": "ข้อมูลการซื้อไม่ตรงรูปแบบการส่งข้อมูลปลอดภาษี",
    "consignor_not_linked": "ยังไม่ได้ผูกบัญชีผู้ฝากขาย",
    "identity_check_required": "ต้องยืนยันตัวตน",
    "consignor_suspended": "บัญชีผู้ฝากขายนี้ถูกพักไว้ — ติดต่อร้าน",
    "consignor_not_active": "ผู้ฝากขายยังไม่พร้อมใช้งาน — ยืนยันตัวตนให้เสร็จก่อน",
    "consignor_close_blocked": "ผู้ฝากยังมีการ์ดหรือเงินอยู่ที่ร้าน — สรุปยอดก่อน",
    "bank_account_required": "จ่ายด้วยการโอนต้องมีบัญชีธนาคาร",
    "bank_account_invalid": "ข้อมูลบัญชีธนาคารไม่ถูกต้อง",
    "customer_already_linked": "บัญชีลูกค้านี้เป็นของผู้ฝากขายคนอื่นแล้ว",
    "payout_in_progress": "กำลังจ่ายเงินให้ผู้ฝากคนนี้อยู่ — ลองใหม่เมื่อเสร็จ",
    "agreement_locked": "สัญญาฉบับนี้ถูกใช้แล้ว — ออกฉบับใหม่แทน",
    "agreement_already_accepted": "ผู้ฝากยอมรับสัญญาฉบับนี้แล้ว",
    "invalid_tiers": "ช่วงราคาค่าคอมต้องเริ่มที่ ¥0 ไม่มีช่องว่างหรือทับกัน และช่วงสุดท้ายไม่มีเพดาน",
    "blocked_minor": "ลูกค้าอายุต่ำกว่า 18 ปีขายหรือฝากขายไม่ได้ถ้าไม่มีหนังสือยินยอมจากผู้ปกครอง",
    "method_not_allowed_for_remote": "วิธียืนยันตัวตนนี้ใช้ได้เฉพาะแบบพบหน้า",
    "method_not_allowed_for_face_to_face": "วิธียืนยันตัวตนนี้ใช้ได้เฉพาะทางไปรษณีย์/ออนไลน์",
    "method_not_allowed_for_foreign_national": "ชาวต่างชาติให้ตรวจบัตรผู้พำนัก (在留カード) หรือพาสปอร์ต",
    "identity_document_expired": "เอกสารยืนยันตัวตนหมดอายุ",
    "identity_check_not_pending": "การยืนยันตัวตนนี้ตรวจแล้วหรือถูกปฏิเสธแล้ว",
    "manager_approval_required": "ต้องให้ผู้จัดการอนุมัติ",
    "document_not_attachable": "ใช้ไฟล์นี้เป็นรูปบัตรไม่ได้ — อัปโหลดใหม่",
    "tax_free_item_check_required": "ยืนยันว่าการ์ดไม่ได้ซื้อแบบปลอดภาษี (免税) ก่อนบันทึกรับซื้อ",
    "counterparty_address_required": "古物台帳 ต้องมีที่อยู่ของผู้ขาย",
    "shogaku_tokurei_not_available": "ข้อยกเว้นยอดน้อยใช้กับการรับซื้อนี้ไม่ได้",
    "kobutsu_entries_exist": "รายการนี้บันทึกใน 古物台帳 แล้ว",
    "kobutsu_correction_invalid": "บันทึกการแก้ไขนี้ไม่ได้ — ตรวจช่องที่แก้",
    "agreement_not_accepted": "ผู้ฝากต้องยอมรับสัญญาฝากขายฉบับล่าสุดก่อน",
    "intake_not_editable": "ใบรับฝากนี้เสร็จหรือยกเลิกแล้ว แก้ไม่ได้",
    "intake_empty": "เพิ่มการ์ดอย่างน้อย 1 ใบก่อนกดเสร็จ",
    "invalid_stage_transition": "ย้ายการ์ดไปสถานะนี้จากสถานะตอนนี้ไม่ได้",
    "proposal_pending": "มีคำขอเปลี่ยนราคาการ์ดใบนี้รอคำตอบอยู่แล้ว",
    "proposal_not_pending": "คำขอเปลี่ยนราคานี้ตอบไปแล้ว",
    "discount_not_editable": "เปลี่ยนการอนุญาตส่วนลดของการ์ดใบนี้ไม่ได้แล้ว",
    "settlement_locked": "จ่ายเงินของการขายนี้ไปแล้ว — ใช้รายการปรับยอดแทน",
    "payout_not_processing": "การจ่ายเงินนี้ทำเครื่องหมายว่าจ่ายแล้วหรือยกเลิกแล้ว",
    "payout_nothing_due": "ตอนนี้ไม่มียอดที่ต้องจ่ายให้ผู้ฝากคนนี้",
    "payout_below_minimum": "ยอดต่ำกว่าขั้นต่ำการจ่าย — จะรวมไปจ่ายรอบหน้า",
    "payout_allocation_invalid": "ยอดจ่ายไม่ตรงกับยอดค้างของการขายเหล่านี้",
    "payout_proof_required": "บันทึกหลักฐานการจ่าย (เลขอ้างอิงการโอน หรือลายเซ็นผู้ฝาก)",
    "store_credit_customer_required": "เครดิตร้านต้องใช้บัญชีลูกค้าของผู้ฝาก — ผูกบัญชีก่อน",
    "statement_not_ready": "ใบสรุปยังเตรียมไม่เสร็จ — ลองใหม่อีกสักครู่",
    "item_reserved": "มีคนกำลังซื้อการ์ดใบนี้อยู่ — คืนตอนนี้ไม่ได้",
    "item_not_returnable": "คืนการ์ดใบนี้จากสถานะตอนนี้ไม่ได้",
    "return_not_editable": "รายการคืนนี้เสร็จหรือยกเลิกแล้ว",
    "customer_not_authenticated": "กรุณาเข้าสู่ระบบเพื่อดูการ์ดที่ฝากขาย",
    "read_only_impersonation": "กำลังดูในฐานะผู้ฝาก — แก้ไขไม่ได้",
    "portal_action_required": "เปลี่ยนสิ่งนี้ได้จากหน้าผู้ฝากขายเท่านั้น",
    "consignor_consent_required": "ต้องได้รับความยินยอมจากผู้ฝากก่อน",
    "verification_required": "ใส่รหัสที่ส่งไปทางอีเมลเพื่อยืนยันการเปลี่ยนแปลงนี้",
    "verification_code_invalid": "รหัสไม่ถูกต้องหรือหมดอายุ",
    "human_check_required": "กรุณายืนยันว่าไม่ใช่โปรแกรมอัตโนมัติ",
    "human_check_failed": "ยืนยันว่าไม่ใช่โปรแกรมอัตโนมัติไม่สำเร็จ — ลองใหม่",
    "manager_pin_required": "ต้องใช้ PIN ของผู้จัดการ",
    "shift_not_open": "เครื่องขายนี้ไม่มีกะที่เปิดอยู่",
    "register_mismatch": "เครื่องขายไม่ตรงกับอุปกรณ์",
    "event_schema_invalid": "เกิดปัญหาที่ฝั่งระบบ",
    "manifest_invalid": "รายการส่วนประกอบหน้าเว็บที่ส่งมาจากหน้าร้านออนไลน์ไม่ถูกต้อง",
    "manifest_version_mismatch": "รุ่นของรายการส่วนประกอบหน้าเว็บไม่ตรงกับเนื้อหา",
    "manifest_not_found": "หน้าร้านออนไลน์ยังไม่ได้ส่งรายการส่วนประกอบหน้าเว็บมา",
    "manifest_missing": "ยังตรวจเว็บไซต์ไม่ได้ — หน้าร้านออนไลน์ยังไม่ได้ส่งส่วนประกอบหน้าเว็บมา",
    "theme_not_found": "ไม่พบดีไซน์นี้",
    "theme_version_not_found": "ไม่มีฉบับที่เผยแพร่นี้",
    "theme_is_live": "ดีไซน์ที่ใช้อยู่บนเว็บเก็บหรือลบไม่ได้ — เผยแพร่ดีไซน์อื่นก่อน",
    "theme_archived": "ดีไซน์นี้ถูกเก็บไว้ — กู้คืนก่อน",
    "theme_incompatible": "ต้องแก้บางส่วนของเว็บไซต์ก่อนเผยแพร่",
    "theme_not_published": "ยังไม่มีดีไซน์ที่เผยแพร่",
    "template_not_found": "ไม่มีเลย์เอาต์หน้านี้",
    "template_exists": "มีเลย์เอาต์หน้านี้อยู่แล้ว",
    "template_is_base": "ลบเลย์เอาต์หลักของหน้าแต่ละประเภทไม่ได้",
    "template_invalid": "เลย์เอาต์หน้ามีปัญหา — ดูรายการ",
    "section_group_invalid": "ส่วนหัว/ท้ายเว็บมีปัญหา — ดูรายการ",
    "policy_required": "หน้าที่กฎหมายบังคับยังไม่ครบทั้งภาษาญี่ปุ่นและอังกฤษ",
    "force_not_allowed": "เฉพาะเจ้าของร้านที่เผยแพร่ได้ขณะหน้ากฎหมายยังไม่ครบ",
    "preview_expired": "ลิงก์ดูตัวอย่างนี้หมดอายุแล้ว",
    "preview_invalid": "ลิงก์ดูตัวอย่างนี้ไม่ถูกต้อง",
    "preview_token_not_found": "ไม่พบลิงก์ดูตัวอย่าง",
    "handle_taken": "ที่อยู่เว็บนี้ถูกใช้กับหน้าอื่นแล้ว",
    "page_not_found": "ไม่มีหน้านี้",
    "page_trashed": "หน้านี้อยู่ในถังขยะ — กู้คืนก่อน",
    "policy_incomplete": "ข้อบังคับบางข้อของหน้ากฎหมายนี้ยังว่างในภาษาญี่ปุ่นหรืออังกฤษ",
    "policy_not_published": "หน้ากฎหมายนี้ยังไม่ได้เผยแพร่",
    "policy_version_not_found": "ไม่มีฉบับนี้ของหน้ากฎหมาย",
    "menu_not_found": "ไม่มีเมนูนี้",
    "menu_item_not_found": "ไม่มีลิงก์นี้ในเมนู",
    "menu_depth_exceeded": "เมนูซ้อนได้ไม่เกิน 3 ชั้น",
    "menu_too_large": "หนึ่งเมนูมีลิงก์ได้ไม่เกิน 200 รายการ",
    "menu_cycle": "วางลิงก์เมนูไว้ในตัวเองไม่ได้",
    "menu_in_use": "เว็บยังแสดงเมนูนี้อยู่ — เอาออกจากเลย์เอาต์หน้าก่อน",
    "redirect_not_found": "ไม่มีการเปลี่ยนเส้นทางของที่อยู่เว็บนี้",
    "redirect_exists": "มีการเปลี่ยนเส้นทางของที่อยู่เว็บนี้อยู่แล้ว",
    "redirect_invalid": "การเปลี่ยนเส้นทางนี้ไม่ถูกต้อง",
    "redirect_loop": "การเปลี่ยนเส้นทางนี้จะพาผู้เข้าชมวนเป็นวงกลม",
    "redirect_chain_too_long": "เปลี่ยนเส้นทางต่อกันหลายทอดเกินไป — ชี้ที่อยู่เก่าไปหน้าสุดท้ายโดยตรง",
    "announcement_not_found": "ไม่มีประกาศนี้",
    "announcement_limit_exceeded": "ประกาศที่แสดงพร้อมกันมากเกินไป — จบหรือปิดสักอันก่อน",
    "locale_not_found": "ร้านยังไม่ได้ตั้งภาษานี้",
    "locale_disabled": "เว็บไซต์ไม่มีภาษานี้",
    "locale_required": "ปิดภาษาอังกฤษและภาษาหลักของเว็บไม่ได้",
    "ui_string_not_found": "ไม่มีข้อความเว็บนี้",
    "ui_string_core": "ลบข้อความมาตรฐานของเว็บไม่ได้ — เปลี่ยนถ้อยคำแทน",
    "placeholder_mismatch": "คำแปลใช้ {ช่องแทรก} ที่ข้อความภาษาอังกฤษไม่มี",
    "icu_syntax_invalid": "ส่วน {…} ของข้อความผิด — ตรวจวงเล็บ",
    "translation_invalid": "บางคำแปลบันทึกไม่ได้ — ยังไม่ได้เปลี่ยนอะไร ดูรายการ",
    "translator_not_configured": "ยังไม่ได้ตั้งการแปลอัตโนมัติ — พิมพ์คำแปลเองหรือถามเจ้าของร้าน",
    "media_item_not_found": "ไฟล์นี้ไม่อยู่ในคลังสื่อ",
    "media_in_use": "เว็บยังใช้ไฟล์นี้อยู่ — เปลี่ยนไฟล์ในจุดเหล่านี้ก่อน",
    "media_folder_not_found": "ไม่มีโฟลเดอร์นี้",
    "media_folder_not_empty": "โฟลเดอร์นี้ยังมีโฟลเดอร์ย่อย — ย้ายหรือลบก่อน",
    "media_tag_not_found": "ไม่มีแท็กนี้",
    "media_name_taken": "มีโฟลเดอร์หรือแท็กชื่อนี้อยู่แล้ว",
    "revalidation_not_found": "ไม่มีการอัปเดตเว็บนี้",
    "revalidation_in_progress": "กำลังส่งการอัปเดตเว็บนี้อยู่ — รอสักครู่",
    "unsupported_format": "ไฟล์นี้ไม่ใช่ไฟล์สำรองดีไซน์ที่ระบบนี้อ่านได้",
    "theme_import_invalid": "ไฟล์ดีไซน์เสียหาย — ดูรายการปัญหา",
    "invalid_credentials": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    "account_locked": "ใส่ผิดหลายครั้งเกินไป บัญชีถูกล็อกชั่วคราว — ลองใหม่ภายหลัง",
    "mfa_code_invalid": "รหัสยืนยันไม่ถูกต้อง",
    "password_too_weak": "รหัสผ่านไม่ตรงตามเงื่อนไข",
    "pin_too_weak": "PIN ต้องเป็นตัวเลข 4–6 หลัก และไม่ใช่เลขเรียงง่ายๆ",
    "challenge_token_invalid": "ลิงก์หรือรหัสนี้ไม่ถูกต้องหรือหมดอายุ",
    "email_already_exists": "มีผู้ใช้อีเมลนี้อยู่แล้ว",
    "role_in_use": "บทบาทนี้ยังมีพนักงานใช้อยู่",
    "system_role_protected": "บทบาทมาตรฐานแก้หรือลบไม่ได้",
    "last_owner_protected": "ทำไม่ได้ เพราะร้านจะไม่มีเจ้าของที่ใช้งานอยู่เลย",
    "unknown_permission": "ไม่รู้จักสิทธิ์นี้",
    "pairing_code_invalid": "รหัสจับคู่ไม่ถูกต้อง ใช้แล้ว หรือหมดอายุ",
    "device_revoked": "อุปกรณ์นี้ไม่ได้จับคู่กับเครื่องขายแล้ว",
    "pin_invalid": "PIN ไม่ถูกต้อง",
    "otp_code_invalid": "รหัสไม่ถูกต้องหรือหมดอายุ",
    "csrf_token_invalid": "ยืนยันการเข้าสู่ระบบไม่ได้ — โหลดหน้าใหม่แล้วลองอีกครั้ง",
    "address_invalid": "ที่อยู่ไม่ถูกต้อง",
    "too_many_addresses": "สมุดที่อยู่เต็มแล้ว",
    "customer_merge_invalid": "รวมลูกค้าเหล่านี้ไม่ได้",
    "export_too_large": "แถวที่ส่งออกมากเกินไป — ลดช่วงวันที่หรือตัวกรองลง",
    "webhook_url_invalid": "ที่อยู่รับการแจ้งเตือนนี้ใช้ไม่ได้"
  }
}
